export default "__VITE_ASSET__bcb0344d__"